var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    rx: 6,
    fill: "#CEEEED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76 102C89.8125 102 101 90.8125 101 77C101 63.1875 89.8125 52 76 52C62.1875 52 51 63.1875 51 77C51 90.8125 62.1875 102 76 102ZM76 114.5C59.3125 114.5 26 122.875 26 139.5V152H126V139.5C126 122.875 92.6875 114.5 76 114.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPatient);
export default __webpack_public_path__ + "static/media/imgPatient.3063e75a1561579120310c39223b8c58.svg";
export { ForwardRef as ReactComponent };